// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___QOIV","title":"styles_title__16H3i","message":"styles_message__t38vF","emptyIcon":"styles_emptyIcon__Xc12R"};